export type RequiredAsteriskProps = {
   size?: 'md' | 'lg';
};

export const RequiredAsterisk = ({ size }: RequiredAsteriskProps) => {
   const lgStyle = size === 'lg' ? { fontSize: '20px', fontWeight: 'bold' } : {};

   return <span style={{ color: 'red', marginLeft: '2px', ...lgStyle }}>*</span>;
};
